import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { RegrelloButton } from "@regrello/ui-core";

export function NeedsConfirmation({
  email,
  isLoading,
  onConfirm,
}: {
  email: string;
  isLoading: boolean;
  onConfirm: (e: React.FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <form className="flex flex-col mt-10 gap-10" onSubmit={onConfirm}>
      <h1 className="flex text-4xl md:text-5xl">{t`Confirm it’s you`}</h1>
      <p className="text-base">
        <Trans>
          To continue, confirm that you are <strong>{email}</strong>.
        </Trans>
      </p>

      <RegrelloButton className="w-full p-3.5 capitalize" intent="primary" loading={isLoading} type="submit">
        {t`Confirm & continue`}
      </RegrelloButton>
    </form>
  );
}
